import React from "react";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import store from "./Store";
import { NotifierProvider } from "./Core/Notifier";
import { ThemeProviderWrapper } from "./Drawer/Menu/ThemeContext";
import GlobalLoader from "./Components/Loader/GlobalLoader";

interface WithAppProvidersProps {}

const withAppProviders =
  (Component: React.ComponentType<WithAppProvidersProps>) =>
  (props: WithAppProvidersProps) => {
    return (
      <Provider store={store}>
        <ThemeProviderWrapper>
          <NotifierProvider>
            <CssBaseline />
            <GlobalLoader />
            <Component {...props} />
          </NotifierProvider>
        </ThemeProviderWrapper>
      </Provider>
    );
  };

export default withAppProviders;
